import { defineMessages } from 'react-intl';

export default defineMessages({
    alertMessage: {
        id: 'ml.agent.quoteandbind.common.confirmation.Congratulations! x been successfully issued',
        defaultMessage: 'Congratulations! This {productName} policy has been successfully issued.',
    },
    purchaseHeader: {
        id: 'ml.agent.quoteandbind.common.views.confirmation.Thank You for choosing us',
        defaultMessage: 'Thank You for choosing us',
    },
    confirmationMessage: {
        id: 'ml.agent.quoteandbind.common.views.confirmation.Confirmation Message',
        defaultMessage: "This policy has been successfully issued. If there is additional information needed from the customer, an Important Reminder box will display below. When shown, please advise the customer of additional information needed from them."
    },
    printConfirmation: {
        id: 'ml.agent.quoteandbind.common.confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    createAccount: {
        id: 'ml.agent.quoteandbind.common.confirmation.GO TO ACCOUNT',
        defaultMessage: 'GO TO ACCOUNT'
    },
    importantReminders: {
        id: 'ml.agent.quoteandbind.common.confirmation.Important reminders for you',
        defaultMessage: 'Important reminders for you'
    },
    watchEmailInbox: {
        id: 'ml.agent.quoteandbind.common.confirmation.watchEmailInbox',
        defaultMessage: 'Watch your email inbox for more information.'
    },
    notifyCurrentCarrier: {
        id: 'ml.agent.quoteandbind.common.confirmation.notifyCurrentCarrier',
        defaultMessage: 'Remember to notify your current carrier of your new policy with us so they can cancel your policy on the effective date listed above.'
    },
    yourPolicyWithProduct: {
        id: 'ml.agent.quoteandbind.common.confirmation.Your X Policy',
        defaultMessage: 'Your {productName} Policy'
    },
    policyDetailsHeader: {
        id: 'ml.agent.quoteandbind.common.confirmation.POLICY DETAILS',
        defaultMessage: 'POLICY DETAILS'
    },
    policyDetailsPolicyNumber: {
        id: 'ml.agent.quoteandbind.common.confirmation.Policy #',
        defaultMessage: 'Policy # {policyNumber}'
    },
    periodStartDate: {
        id: 'ml.agent.quoteandbind.common.confirmation.Effective Date:',
        defaultMessage: 'Effective Date: {effectiveDate}'
    },
    periodExpirationDate: {
        id: 'ml.agent.quoteandbind.common.confirmation.Expiration Date:',
        defaultMessage: 'Expiration Date: {expirationDate}'
    },
    endingInXXX: {
        id: 'ml.agent.quoteandbind.common.confirmation.Ending in XXX',
        defaultMessage: 'Ending in {cardNumber}'
    },
    downPayment: {
        id: 'ml.agent.quoteandbind.common.confirmation.DOWN PAYMENT',
        defaultMessage: 'DOWN PAYMENT'
    },
    downPaymentMethod: {
        id: 'ml.agent.quoteandbind.common.confirmation.Down Payment Method',
        defaultMessage: 'Down Payment Method:'
    },
    paymentAmount: {
        id: 'ml.agent.quoteandbind.common.confirmation.Payment Amount',
        defaultMessage: 'Payment Amount:'
    },
    paymentDate: {
        id: 'ml.agent.quoteandbind.common.confirmation.Payment Date',
        defaultMessage: 'Payment Date:'
    },
    confirmationNumber: {
        id: 'ml.agent.quoteandbind.common.confirmation.Confirmation #',
        defaultMessage: 'Confirmation #:'
    },
    paymentMethod: {
        id: 'ml.agent.quoteandbind.common.confirmation.Payment method:',
        defaultMessage: 'Payment method:'
    },
    insured: {
        id: 'ml.agent.quoteandbind.common.confirmation.INSURED',
        defaultMessage: 'INSURED'
    },
    coInsured: {
        id: 'ml.agent.quoteandbind.common.confirmation.CO-INSURED',
        defaultMessage: 'CO-INSURED'
    },
    propertyAddress: {
        id: 'ml.agent.quoteandbind.common.confirmation.PROPERTY ADDRESS',
        defaultMessage: 'PROPERTY ADDRESS'
    },
    vehiclesHeader: {
        id: 'ml.agent.quoteandbind.common.confirmation.VEHICLES',
        defaultMessage: 'VEHICLES'
    },
    vehicleNamedNonOwner: {
        id: 'ml.agent.quoteandbind.common.confirmation.Named Non-Owner',
        defaultMessage: 'Named Non-Owner'
    }
});
